import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxNavbar = _resolveComponent("PxNavbar")!
  const _component_MilestonePlannerAccessModal = _resolveComponent("MilestonePlannerAccessModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$screen.mdUp)
      ? (_openBlock(), _createBlock(_component_PxNavbar, {
          key: 0,
          items: _ctx.activeNavBarItems,
          "show-account-dropdown": _ctx.$user.isLogged()
        }, null, 8, ["items", "show-account-dropdown"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "access-plan-guard__background",
      src: "/img/illustrations/milestone-planner/access-background.png"
    }, null, -1)),
    _createVNode(_component_MilestonePlannerAccessModal, { "requires-passcode": _ctx.requiresPasscode }, null, 8, ["requires-passcode"])
  ]))
}